export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_PROFILE_REQUEST = "AUTH_PROFILE_REQUEST";
export const AUTH_PROFILE_SUCCESS = "AUTH_PROFILE_SUCCESS";
export const HANDLE_MSAL_RESPONSE = "HANDLE_MSAL_RESPONSE";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
